import { exactTime } from './StatusPieces';

export { agoShort, agoSpoken } from './agoText';
import { agoShort } from './agoText';

/** "2h ago" as a <time> element: machine-readable, exact on hover. */
export function Ago({ iso, className }: { iso: string | null | undefined; className?: string }) {
  if (!iso) return <span className={className}>never</span>;
  return (
    <time className={className} dateTime={iso} title={exactTime(iso)}>
      {agoShort(iso)}
    </time>
  );
}
